import ResourceModel from "models/convention-api/ResourceModel"

export default class VideoCount extends ResourceModel {
  protected static basePath = "/v1/convention_providers/:provider_id/video_counts"

  count!: number
}
